import { render, staticRenderFns } from "./orderItem.vue?vue&type=template&id=6b96ecd3&scoped=true&"
import script from "./orderItem.vue?vue&type=script&lang=ts&"
export * from "./orderItem.vue?vue&type=script&lang=ts&"
import style0 from "./orderItem.vue?vue&type=style&index=0&id=6b96ecd3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96ecd3",
  null
  
)

export default component.exports